<mat-nav-list class="p-0">
  <div class="pt-2 pb-2 text-center">
    <img class="w-50 h-75" src="../../../assets/img/logo.jpg">
  </div>
  <h1 class="text-center text-bold mb-4" id="logoText">WiMove
  </h1>
  <mat-divider />
  @for (item of menuItems(); track item) {
  <a class="menu-item" mat-list-item [routerLink]="item.route" (click)="toggleSubmenu(item)"
    routerLinkActive="selected-menu-item">
    <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
    <div class="d-flex justify-content-start align-items-center">
      <span>{{ item.label }}</span>
      @if (item.submenu && item.submenu.length > 0) {
      <mat-icon>{{ isSubmenuOpen(item) ? 'expand_less' : 'expand_more' }}</mat-icon>
      }
    </div>
  </a>
  @if (isSubmenuOpen(item)) {
  <mat-list class="p-0">
    @for (subItem of item.submenu; track subItem) {
    <a mat-list-item [routerLink]="subItem.route" routerLinkActive="selected-menu-item" class="menu-item ms-3">
      <div class="d-flex align-items-center justify-content-start">
        <mat-icon matListIcon class="pt-1 fs-6">{{ subItem.icon }}</mat-icon>
        <span>{{ subItem.label }}</span>
      </div>
    </a>
    }
  </mat-list>
  }
  }
</mat-nav-list>